<app-header [icon]="'close'" (iconClickedEvent)="close()"></app-header>
<app-stepper #stepper></app-stepper>

<div class="container">

  <div class="sub-title">
    {{ 'body_reactions.title' | translate }}
  </div>

  <app-select-list 
    [list]="listBodyReactions()"
    (addItem)="addNewBodyReaction($event)"
    (deleteItem)="deleteBodyReaction($event)"
  >
  </app-select-list>

  <div class="actions-container">
    <app-button
      [buttonLabel]="'buttons.back' | translate"
      [buttonType]="BUTTON_TYPES.OUTLINED" 
      [buttonDisabled]="false"
      (click)="back()">
    </app-button>
    <app-button
      [buttonLabel]="'buttons.next' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR" 
      [buttonDisabled]="false"
      (click)="next()">
    </app-button>
  </div>
</div>